import { useState, useRef, useEffect } from 'react'
import { useLang } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'
import CGU from './CGU'

const CreateEmail = ({
  doSubscribe,
  emailNotUsed,
  onConfirmEmail,
  title,
  pwdLostEmailExist,
  showCGU,
  onCancel,
}) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng
  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(false)
  const [cguAccept, setCguAccept] = useState(false)

  const first = useRef(null)

  useEffect(() => {
    if (!first.current) return
    first.current.focus()
  }, [])

  useEffect(() => {
    if (emailNotUsed === false) setCguAccept(false)
  }, [emailNotUsed])

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  const onEmailChange = (e) => {
    setEmail(e.target.value)
    setValidEmail(validateEmail(e.target.value))
  }

  const handleAcceptChange = () => {
    setCguAccept(!cguAccept)
  }

  return (
    <>
      {!emailNotUsed && (
        <div className="notification is-danger is-light">
          <span className="icon is-small is-left">
            <i className="fa fa-exclamation-triangle"></i>
          </span>
          {'  '}
          {choosenLang.alertAddressUsed}
        </div>
      )}

      {pwdLostEmailExist === 0 && (
        <div className="notification is-danger is-light">
          <span className="icon is-small is-left">
            <i className="fa fa-exclamation-triangle"></i>
          </span>
          {'  '}
          {choosenLang.noAccountWithEmail}
        </div>
      )}

      <div className="field">
        <label className="label">{title} </label>
        <div className="control has-icons-left has-icons-right">
          <input
            className={'input ' + (validEmail ? 'is-primary' : 'is-danger')}
            type="text"
            placeholder={title}
            value={email}
            onChange={onEmailChange}
            ref={first}
          />
          <span className="icon is-small is-left">
            <i className="fa fas fa-envelope"></i>
          </span>
          {!validEmail && (
            <span className="icon is-small is-right">
              <i className="fa fa-exclamation-triangle"></i>
            </span>
          )}
        </div>
        <p className="help is-danger">
          {validEmail ? '' : email.length > 0 ? choosenLang.alertAddress : ''}
        </p>
        <br />
        {showCGU === true && (
          <CGU accept={cguAccept} handleAcceptChange={handleAcceptChange} />
        )}

        <div className="field is-grouped">
          <p className="control">
            <button
              className={'button ' + (doSubscribe ? 'is-info ' : 'is-primary')}
              onClick={() => {
                onConfirmEmail(email)
              }}
              disabled={!validEmail || (!cguAccept && showCGU === true)}
            >
              {choosenLang.continue}
            </button>
          </p>
          <p className="control">
            <button className="button is-light " onClick={onCancel}>
              {choosenLang.cancel}
            </button>
          </p>
        </div>
      </div>
    </>
  )
}

export default CreateEmail
